// 用户反馈表单组件
export default {
  // 页面标题
  title: "用户反馈列表",
  subtitle: "使用过程中遇到的问题？",

  // 表单标签
  problemType: "问题类型",
  problemDescription: "问题描述",
  phoneNumber: "手机号",
  email: "邮箱",

  // 问题类型选项
  problemFeedback: "问题反馈",
  featureSuggestion: "功能建议",
  caseAssistance: "案情协助",

  // 占位符
  phonePlaceholder: "请输入手机号",
  emailPlaceholder: "请输入邮箱",

  // 按钮
  reset: "重置",
  submit: "提交",
  close: "关闭",
  confirm: "确认",

  // 成功提示
  submitSuccess: "提交成功，感谢您的建议",

  // 表单验证
  phoneRequired: "请输入手机号",
  phoneLengthRule: "长度在 7 到 12 个字符",
  emailRequired: "请输入邮箱",
  typeRequired: "请选择问题类型",
  contentRequired: "请填写问题描述",
};
